import PropTypes from 'prop-types';
import relationshipsPropTypes, {
  imagePropTypes,
  rubricPropTypes,
} from 'core/utils/prop-types/relationships';
import themePropTypes from 'core/utils/prop-types/theme';
import resolveRelationships from 'core/utils/relationships';

import withCard from 'core/hocs/withCard';
import SmartImage from 'core/components/SmartImage/Amp';


const relationships = resolveRelationships(['image', 'rubric'], {}, {
  image: {
    versions: {},
  },
  rubric: {},
});

function Card1(props) {
  const {
    externalLink,
    content,
    theme,
  } = props;

  const {
    attributes: {
      link,
      headline,
      source_url: sourceUrl,
    },
  } = content;

  const {
    image: {
      versions: {
        original: cover,
      },
    },
    rubric: {
      title: rubricTitle,
    },
  } = relationships(content);

  const url = externalLink ? sourceUrl : link;

  return (
    <a href={url} className='card'>
      <style jsx>{`
        .card
          width 220px
          display block
          text-decoration none
          font-size 14px
          border-radius 4px
          overflow hidden
        .image
          width 220px
          height 130px
          :global(amp-img img)
            object-fit cover
        .headline
          white-space normal
          height 75px
          overflow hidden
          margin-bottom 10px
        .text
          padding 12px 10px 10px
        .rubric
          font-size 12px
      `}
      </style>
      <style jsx>{`
        .card
          color ${theme.colors.primary}
          background-color ${theme.colors.card}
        .rubric
          color ${theme.colors.hint}
      `}
      </style>
      {cover && (
        <div className='image'>
          <SmartImage
            src={cover}
            width={220}
            height={130}
          />
        </div>
      )}
      <div className='text'>
        <div className='headline'>{headline}</div>
        <div className='rubric'>{rubricTitle}</div>
      </div>
    </a>
  );
}

Card1.propTypes = {
  /**
   * Ссылка для перехода
   */
  externalLink: PropTypes.bool,

  /** @ignore */
  content: relationshipsPropTypes({
    image: imagePropTypes(),
    rubric: rubricPropTypes(),
  }),

  /** @ignore */
  theme: themePropTypes(`{
    colors: {
      primary,
      active1,
    },
    fonts: {
      text,
    }
  }`),
};

const Card = withCard(Card1);

Card.displayName = 'Card1';

export default Card;
export { Card1 as StorybookComponent };
